/* Reseller Hub entry pop-up V2 (15 Oct 2026), SPEC 12. Rules and copy: snippets/hub-entry-pop.liquid
   V2 adds Bob: his avatar (svw-bob-avatar.js + svw-pop-bob.css) loads only once the pop-up has passed every rule and is
   about to show; up to 4 s, then it shows without him (.svw-pop--nobob). */
(function(W,D){
var R=D.getElementById('svw-pop');
if(!R||R.dataset.on||W.top!==W||D.querySelector('.svw-hub'))return;
R.dataset.on=1;
var C=R.querySelector('.svw-pop__card'),K='svw_hub_pop_v1',T0=Date.now(),up=0,n=0,css=0,back,modal,raf,mo,tm,
bobSt=0,host,av,tw=[],
qa=R.hasAttribute('data-qa')&&/[?&]hubpop=1(&|$)/.test(location.search);
function id(x){return D.getElementById(x)}
function on(t,e,f,o){t.addEventListener(e,f,o)}
function off(t,e,f,o){t.removeEventListener(e,f,o)}
function ls(){try{return W.localStorage}catch(e){}}
function save(v){try{ls().setItem(K,JSON.stringify(v));return 1}catch(e){}}
function vis(e){return!!(e&&e.getClientRects().length&&getComputedStyle(e).visibility!='hidden')}
function prefOK(){try{var P=W.Shopify&&Shopify.customerPrivacy;return!!(P&&P.preferencesProcessingAllowed&&P.preferencesProcessingAllowed())}catch(e){}}
function cover(){var b=D.body,B=W.SVWBob&&SVWBob.chat;
return vis(id('shopify-pc__banner'))||vis(id('svw-reveal'))||/overflow-hidden/.test(b.className)||b.style.position=='fixed'||!!D.querySelector('dialog[open]')||!!(B&&B.isOpen&&B.isOpen())}
function busy(){var a=D.activeElement;return D.hidden||cover()||!!(a&&(/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)||a.isContentEditable))}
function bob(){if(!id('svw-bob'))return;if(vis(D.querySelector('.svb-say:not([hidden])')))return 1;
try{return sessionStorage.getItem('svw-bob:v1:greeted')!='1'}catch(e){}}
function trig(){if(tm){clearTimeout(tm);tm=0;off(W,'scroll',sc);go()}}
function sc(){var h=D.documentElement.scrollHeight-innerHeight;if(h>0&&scrollY/h>=.35)trig()}
function sheet(u,f){var l=D.createElement('link');l.rel='stylesheet';l.href=u;l.onload=function(){f(1)};l.onerror=function(){f(0)};D.head.appendChild(l)}
/* Bob: his CSS + the avatar script, 0 = not asked, 1 = loading, 2 = ready, 3 = failed or too slow */
function loadBob(){
if(bobSt)return;bobSt=1;
var need=2,ok=1,t=setTimeout(function(){done(0)},4e3);
function done(g){if(bobSt!=1)return;ok=ok&&g;if(g&&--need)return;clearTimeout(t);bobSt=ok&&W.SVWBob&&SVWBob.avatar&&SVWBob.avatar.mount?2:3;go()}
sheet(R.dataset.bobCss,done);
if(W.SVWBob&&SVWBob.avatar&&SVWBob.avatar.mount)return done(1);
var s=D.createElement('script');s.src=R.dataset.bobJs;s.async=true;s.onload=function(){done(1)};s.onerror=function(){done(0)};D.head.appendChild(s)}
function go(){
if(up||innerHeight<500)return;
if(busy()){if(++n<15)setTimeout(go,2e3);return}
if(!qa){var s=prefOK()&&ls(),v,d;
try{if(!s||s.getItem('svw_hub_v1'))return;v=JSON.parse(s.getItem(K))||{}}catch(e){return}
d=Date.now()-v.t;if(v.c||d>=0&&d<6048e5)return}
var w=bob()?1e4-(Date.now()-T0):0;
if(w>0)return void setTimeout(go,w);
loadBob();
if(!css){if(css===0){css=null;sheet(R.dataset.css,function(g){css=g?1:-1;go()})}return}
if(css<0||bobSt<2)return;
if(qa||save({t:Date.now()}))show()}
function later(f,ms){tw.push(setTimeout(f,ms))}
function act(a){try{if(av&&host)a=='think'||a=='idle'?av.setState(a):av.play(a)}catch(e){}}
function show(){
modal=!!(W.matchMedia&&matchMedia('(min-width: 750px)').matches);
back=D.activeElement;
C.setAttribute('aria-modal',modal);
R.classList.toggle('svw-pop--m',modal);
R.classList.toggle('svw-pop--nobob',bobSt!=2);
R.hidden=false;up=1;
if(bobSt==2){av=SVWBob.avatar;try{host=av.mount(R.querySelector('[data-pop-bob="'+(modal?'m':'p')+'"]'),{size:'desktop'});av.setState('idle')}catch(e){host=0}
if(!host)R.classList.add('svw-pop--nobob');else later(function(){act('wave')},modal?1400:900)}
later(function(){R.classList.add('svw-pop--done')},2600);
if(modal)C.focus({preventScroll:true});else{place();on(W,'scroll',place,{passive:true});on(W,'resize',place)}
on(D,'focusin',away,true);
if(W.MutationObserver)(mo=new MutationObserver(function(){if(cover())shut(1)})).observe(D.body,{attributes:true,attributeFilter:['class','style']})}
/* phones: under the header while it shows */
function place(){raf=raf||requestAnimationFrame(function(){
var y=0,q=D.querySelectorAll('.shopify-section-group-header-group,.svw-delaybar'),i,r;raf=0;
for(i=0;i<q.length;i++){r=q[i].getBoundingClientRect();if(r.height)y=Math.max(y,r.bottom)}
R.style.top=Math.round(Math.min(Math.max(y,0),innerHeight*.4)+8)+'px'})}
function away(e){if(!C.contains(e.target))shut(1)}
function shut(left){
if(!up)return;
var had=C.contains(D.activeElement),t;
up=0;R.hidden=true;R.style.top='';
tw.forEach(clearTimeout);tw=[];
if(host){try{host.unmount()}catch(e){}host=0}
off(D,'focusin',away,true);off(W,'scroll',place);off(W,'resize',place);
if(mo)mo.disconnect();
if(left||!(had||modal))return;
t=back&&back!=D.body&&D.contains(back)?back:id('MainContent');
try{t.focus({preventScroll:true})}catch(e){}}
function skip(){if(!R.classList.contains('svw-pop--done')){R.classList.add('svw-pop--done');tw.forEach(clearTimeout);tw=[];act('wave')}}
on(R,'pointerdown',function(e){if(!(e.target.closest&&e.target.closest('[data-pop-x],[data-pop-go]')))skip()});
on(R,'click',function(e){var t=e.target.closest&&e.target.closest('[data-pop-x],[data-pop-go]');
if(t&&t.hasAttribute('data-pop-go')){if(!qa)save({t:Date.now(),c:1})}else if(t)shut(0)});
/* Bob reacts: laptop out over the buy button, a shrug over "Not now" */
var buy=R.querySelector('[data-pop-buy]'),no=R.querySelector('.svw-pop__no');
if(buy){on(buy,'pointerenter',function(){act('think')});on(buy,'pointerleave',function(){act('idle')})}
if(no)on(no,'pointerenter',function(){act('shrug')});
/* Esc + focus loop: dialog only */
on(C,'keydown',function(e){
if(e.key=='Escape'){e.stopPropagation();return shut(0)}
skip();
if(e.key!='Tab'||!modal)return;
var f=[].slice.call(C.querySelectorAll('a[href],button')).filter(vis),i=f.indexOf(D.activeElement),L=f.length;
/* by hand: Shopify's banner script eats a Tab */
e.preventDefault();f[e.shiftKey?(i<1?L-1:i-1):(i+1)%L].focus()});
tm=setTimeout(trig,qa?1e3:6e3);
on(W,'scroll',sc,{passive:true});
})(window,document);
